import getResourcesForTheme from './getResourcesForTheme';
import { getThemeIdFromParameter } from '../utils/optionalArgumentHelpers';

export default function getFallbackBackgroundColor(
    themeId?: string,
    isDarkTheme?: boolean
): string {
    themeId = getThemeIdFromParameter(themeId);

    return getResourcesForTheme(themeId, isDarkTheme).background?.fallbackColor ?? 'transparent';
}
